<template>

    <LoopItemPanel title="Categorie selecteren">

        <div class="common-canvas-blocks-custom-category-admin-LoopItemPanel">

            <div class="tw-px-4 tw-py-3 text">

                <div class="tw-mb-1 tw-text-gray-600 label">Grootte</div>

                <v-select
                    :options="[
                        { 'type': 'small', 'name': 'Small size' },
                        { 'type': 'medium', 'name': 'Half size item' },
                        { 'type': 'mediumColored', 'name': 'Half size item with color' },
                        { 'type': 'large', 'name': 'Big size item' },
                    ]"
                    label="name"
                    index="type"
                    v-model="loopItem.size">

                    <div slot="no-options">Geen opties</div>

                </v-select>

            </div>

            <div class="tw-px-4 tw-py-3 text">

                <div class="tw-mb-1 tw-text-gray-600 label">Type item</div>

                <v-select
                    :options="[
                        { 'type': 'event', 'name': 'Event' },
                        { 'type': 'contentitem', 'name': 'Content item' },
                        { 'type': 'auto', 'name': 'Automatisch vullend' }
                    ]"
                    label="name"
                    index="type"
                    v-model="loopItem.type"
                    @input="manageType()">

                    <div slot="no-options">Geen opties</div>

                </v-select>

            </div>

            <div class="tw-px-4 tw-py-3 text" v-if="loopItem.type && loopItem.type.type == 'event'">

                <div class="tw-mb-1 tw-text-gray-600 label">Selecteer een event</div>

                <v-select
                    :options="events"
                    label="name"
                    index="id"
                    v-model="loopItem.event">

                    <div slot="no-options">Geen opties</div>

                </v-select>

            </div>

            <div class="tw-px-4 tw-py-3 text" v-if="loopItem.type && loopItem.type.type == 'contentitem'">

                <div class="tw-mb-1 tw-text-gray-600 label">Selecteer een content item</div>

                <v-select
                    :options="contentitems"
                    label="name"
                    index="id"
                    @search="onSearch"
                    v-model.lazy="loopItem.contentItem">

                    <template v-slot:option="contentitem">
                        <span>{{ contentitem.name }}</span>
                        <span class="ml-1 text-gray-500 text-xs">- {{ contentitem.created_at | formatDate }}</span>
                    </template>

                    <div slot="no-options">Geen opties</div>

                </v-select>

            </div>

            <!--
            <div class="tw-px-4 tw-py-3 text">

                <div class="tw-mb-1 tw-text-gray-600 label">Item staat vast?</div>

                <input
                    type="checkbox"
                    v-model="loopItem.forced"
                />

            </div>
            -->

        </div>

    </LoopItemPanel>

</template>

<script>

    import axios from 'axios';
    import LoopItemPanel from "@galaxy/js/common/canvas/editor/canvas/document/editors/loop/LoopItemPanel";

    export default {

        extends: LoopItemPanel,

        components: {
            LoopItemPanel,
        },

        data()
        {
            return {
                events: [],
                contentitems: [],
            };
        },

        created()
        {
            this.loadAllModels();
        },

        methods: {

            manageType()
            {
                // If type gets changed to auto
                if( this.loopItem.type.type === 'auto' ) {
                    this.loopItem.contentItem = null;
                    this.loopItem.event = null;
                }
            },

            async loadAllModels()
            {
                // Load models.
                this.events = (await axios.get(this.adminUrlPrefix + '/events')).data;
                this.contentitems = (await axios.get(this.adminUrlPrefix + '/contentitems')).data;
            },

            async onSearch(search, loading) {
                // Set as loading
                loading(true);

                // Load items
                this.contentitems = (await axios.get(this.adminUrlPrefix + '/contentitems?q=' + search)).data;

                // Set loading false
                loading(false);
            }

        },

        computed: {

            optionsItems()
            {
                return this.canvasBlock.options.contentitems;
            },

            optionsItem()
            {
                return this.contentitems[this.itemIndex];
            },

            itemIndex()
            {
                return this.editorComponent.$parent.$children.indexOf(this.editorComponent);
            },

        },

        filters: {

            formatDate(value)
            {
                return moment(value).format('D MMMM YYYY');
            },

        },

    }

</script>

<style lang="scss" scoped>

    .common-canvas-blocks-custom-category-admin-LoopItemPanel {



    }

</style>